import { IArtistExternalId } from './externalId.interface';
import { IArtistLabel } from './label.interface';
import { IArtistName } from './name.interface';

export interface IArtist{
  Id: string;
  Name?: IArtistName;
  Nickname: string;
  Email?: string;
  PhoneNumberPrefix?: string;
  PhoneNumber?: string;
  Remarks?: string;
  ArtistStatus: number;
  IsBand: boolean;
  ArtistsInBand?: string[]; // out in listing
  AddedByLabel?: IArtistLabel;
  ProfilePictureLink?: string;
  ProfilePicturePreviewLink?: string;
//   ArtistFiles?: ArtistFile[]; // out in listing
  ExternalIds?: IArtistExternalId[];
}


export interface IArtistMock{
  Id: string;
  Name?: string;
  Nickname: string;
  Email?: string;
  PhoneNumber?: string;
  ArtistStatus: number;
  IsBand: boolean;
  ExternalIds?: IArtistExternalId[];
}

export enum ARTIST_TYPE {
   true = 'Band',
   false = 'Solist'
}
